var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-1",attrs:{"color":"primary","small":"","dense":"","disabled":_vm.disableLink,"to":{name: 'TechnicalVisitView', query: { uuid: _vm.customer.uuid, fieldUuid: _vm.field.uuid }}}},[_vm._v(" "+_vm._s(_vm.$t('newAssessment'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }